import Mention from "@tiptap/extension-mention";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { TiptapMentionNodeView } from "../components/tiptap-mention-node-view";

/**
 * Custom Mention Extension
 * STRICT ARCHITECTURE COMPLIANCE: Extension only
 * - Extends existing Mention extension
 * - Adds React node view for Tag components
 * - Uses existing autocomplete system
 */

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    customMention: {
      /**
       * Insert a mention
       */
      insertMention: (options: { id: string; label: string }) => ReturnType;
    };
  }
}

export interface CustomMentionOptions {
  HTMLAttributes: Record<string, unknown>;
}

export const CustomMention = Mention.extend({
  addNodeView() {
    return ReactNodeViewRenderer(TiptapMentionNodeView);
  },

  addCommands() {
    return {
      insertMention:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          });
        },
    };
  },
});
